// src/components/layouts/RegularLayout.jsx
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";

const layoutCss = `
.regular-layout{
  --sb-w: 260px;
  --sb-w-mini: 72px;
  --sidebar-w: var(--sb-w);
  --shell-max: clamp(1120px, 92vw, 1760px);
  --page-pad: clamp(12px, 2vw, 28px);

  height: 100dvh;
  overflow: hidden; /* IMPORTANT: scroll pindah ke .content-shell */
  background: #f6f8f7;
}

/* Sidebar pinned */
.regular-layout .sidebar{
  position: fixed;
  left: 0; top: 0;
  width: var(--sidebar-w);
  height: 100dvh;
  z-index: 2000;
}

/* CONTENT: ini scroller utama */
.regular-layout .content-shell{
  position: relative;
  margin-left: var(--sidebar-w);
  width: calc(100% - var(--sidebar-w));
  height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f6f8f7;
  scrollbar-gutter: stable both-edges;
  box-sizing: border-box;
}

/* konten dipusatkan DI DALAM scroller */
.regular-layout .content-inner{
  width: min(100%, var(--shell-max));
  margin: 0 auto;
  padding: var(--page-pad);
  box-sizing: border-box;
  min-height: 100%;
}

/* Sinkron collapsed */
.regular-layout .sidebar[data-collapsed="true"] ~ .content-shell{
  margin-left: var(--sb-w-mini);
  width: calc(100% - var(--sb-w-mini));
}

/* Mobile: sidebar slide, content full */
@media (max-width: 992px){
  .regular-layout .sidebar{ width: min(84vw, 320px); }
  .regular-layout .content-shell{
    margin-left: 0;
    width: 100%;
  }
}

/* aksesibilitas */
@media (prefers-reduced-motion: reduce){
  .regular-layout * { animation:none !important; transition:none !important; scroll-behavior:auto !important; }
}
`;

export default function RegularLayout() {
  // optional: kalau kamu mau kontrol open/close sidebar dari layout
  const [sbOpen, setSbOpen] = useState(false);

  return (
    <div className="regular-layout">
      <style>{layoutCss}</style>

      {/* Sidebar: mobile akan slide pakai prop isOpen */}
      <Sidebar isOpen={sbOpen} onClose={() => setSbOpen(false)} />

      {/* tombol buka sidebar di mobile (biar selalu bisa akses menu) */}
      <button
        type="button"
        onClick={() => setSbOpen(true)}
        aria-label="Buka menu"
        style={{
          display: "none",
          position: "fixed",
          left: 12,
          top: 12,
          zIndex: 2500,
          width: 44,
          height: 44,
          borderRadius: 12,
          border: "1px solid rgba(0,0,0,.12)",
          background: "#fff",
          fontWeight: 900,
          cursor: "pointer",
        }}
        className="sb-open-btn"
      >
        ☰
      </button>

      <style>{`
        @media (max-width: 992px){
          .sb-open-btn{ display: grid !important; place-items:center; }
        }
      `}</style>

      <main className="content-shell">
        <div className="content-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
